document.addEventListener('DOMContentLoaded', function() {
    const slider = document.querySelector('.slider');
    const slides = Array.from(document.querySelectorAll('.before-after-block'));
    const slideWidth = slides[0].offsetWidth; 
    let currentIndex = 0;

    slider.innerHTML += slider.innerHTML;

    function moveToNextSlide() {
        currentIndex++;
        if (currentIndex >= slides.length) {
            slider.style.transition = 'none'; 
            currentIndex = 0;
            slider.style.transform = `translateX(0)`;
            setTimeout(() => {
                slider.style.transition = 'transform 0.5s ease-in-out'; // Re-enable transition
                slider.style.transform = `translateX(-${slideWidth * currentIndex}px)`;
            }, 20);
        } else {
            slider.style.transform = `translateX(-${slideWidth * currentIndex}px)`;
        }
    }


    document.querySelector('.prev-btn').addEventListener('click', function() {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        slider.style.transform = `translateX(-${slideWidth * currentIndex}px)`;
    });

    document.querySelector('.next-btn').addEventListener('click', function() {
        moveToNextSlide();
    });
});


document.addEventListener('DOMContentLoaded', function () {
    var links = document.querySelectorAll('.play-video-link');
    var popups = document.querySelectorAll('.video-popup');
    var closeButtons = document.querySelectorAll('.close-popup');

    links.forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var popupId = link.getAttribute('href').substring(1);
            var popup = document.getElementById(popupId);
            popup.style.display = 'block';
        });
    });

    closeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var popup = button.closest('.video-popup');
            popup.style.display = 'none';
        });
    });

    window.addEventListener('click', function (e) {
        if (e.target.classList.contains('video-popup')) {
            e.target.style.display = 'none';
        }
    });
});


document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.slider');
    const progressBar = document.querySelector('.progress--bar');
    const prevBtn = document.querySelector('.prev-btn');
    const nextBtn = document.querySelector('.next-btn');

    function updateProgressBar() {
        if (!slider || !progressBar) return;

        const sliderWidth = slider.scrollWidth;
        const visibleWidth = slider.clientWidth;
        const maxScroll = sliderWidth - visibleWidth;
        let scrollAmount = 0;
        if (slider.style.transform) {
            const translateX = getTranslateXValue(slider.style.transform);
            scrollAmount = Math.abs(translateX);
        } else {
            scrollAmount = slider.scrollLeft;
        }

        const scrollPercentage = maxScroll > 0 ? (scrollAmount / maxScroll) * 100 : 0;
        progressBar.style.width = `${scrollPercentage}%`;
    }

    function slideBy(amount) {
        if (!slider) return;
        if (slider.style.transform) {
            let currentTransform = slider.style.transform;
            let currentTranslateX = getTranslateXValue(currentTransform);
            let newTranslateX = currentTranslateX - amount;
            newTranslateX = Math.max(-slider.scrollWidth + slider.clientWidth, newTranslateX);
            newTranslateX = Math.min(0, newTranslateX);

            slider.style.transform = `translateX(${newTranslateX}px)`;
        } else {
            slider.scrollLeft += amount;
        }

        updateProgressBar();
    }

    function getTranslateXValue(transformValue) {
        const match = /translateX\((-?\d+)px\)/.exec(transformValue);
        return match ? parseInt(match[1], 10) : 0;
    }

    function getScrollAmount() {
        return window.innerWidth > 768 ? Math.min(100, slider.scrollWidth / 5) : 50;
    }
    updateProgressBar();
    slider.addEventListener('scroll', updateProgressBar);
    window.addEventListener('resize', updateProgressBar);

    prevBtn.addEventListener('click', function () {
        slideBy(-getScrollAmount());
    });

    nextBtn.addEventListener('click', function () {
        slideBy(getScrollAmount());
    });
});